module.exports = __webpack_public_path__ + "static/media/used-print-header - Copy.668e79fc.jpg";